// material-ui

import inspectionicon from '../../../assets/images/inspection.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const InspectionIcon = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={inspectionicon} alt="Inspection" width="45" className={props.className || 'abc'}  />
    );
};

export default InspectionIcon;